function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { notification } from 'antd';
import { getClassNames, simpleNotification } from '../../utils';
import { InfoCircleOutlined } from '@ant-design/icons';
export var FormLayoutRow = function FormLayoutRow(props) {
  var _props$copyValue, _props$infoIcon;

  var onCopied = React.useCallback(function (text, result) {
    notification.destroy();

    if (result) {
      simpleNotification('success', "Your ".concat([props.label], " has been copied!"));
    }
  }, [props.label]);
  var ValueWrapper = props.value && props.copyEnabled ? CopyToClipboard : function (_) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, _.children);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row')
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row-label')
  }, props.label), props.value && /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row-value', _defineProperty({}, 'can-copy', props.copyEnabled))
  }, /*#__PURE__*/React.createElement(ValueWrapper, {
    onCopy: props.onCopied ? props.onCopied : onCopied,
    text: (_props$copyValue = props.copyValue) !== null && _props$copyValue !== void 0 ? _props$copyValue : props.value
  }, /*#__PURE__*/React.createElement("span", null, props.value))), props.info && /*#__PURE__*/React.createElement("div", {
    className: getClassNames('form-layout-row-sub')
  }, (_props$infoIcon = props.infoIcon) !== null && _props$infoIcon !== void 0 ? _props$infoIcon : /*#__PURE__*/React.createElement(InfoCircleOutlined, null), /*#__PURE__*/React.createElement("span", null, props.info)));
};